import {StoreType} from '../../../types/sharedTypes';

export const carrierUserParamsSelector = (state: StoreType) => {
  return state.carrierUserReducer.params;
}

export const allCarrierUsersSelector = (state: StoreType) => {
  return state.carrierUserReducer.carrierUsersResult;
}
